import { SettingComponent } from "../../components";

export default function HomeSettingPage() {
  return <SettingComponent.HomeSettingPage />;
}
